
// SVG Icon: zoom-in
export default { id: "terriajs-zoom-in" };
export const id = "terriajs-zoom-in";
export const name = "zoom-in";
